import { Link } from "react-router-dom";
import { useData } from "../../hooks/useData";
import Icon from "../Icon";
import Logo from "../ui-custom/Logo";

export default function Footer() {
  const { data } = useData("footer");
  const { data: site } = useData("site");
  const { data: links } = useData("links");
  if (!data) return null;

  return (
    <footer className="relative mt-20 border-t border-slate-200/70" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-[1.4fr_repeat(4,1fr)]">
        <div>
          <Logo className="text-2xl" />
          <p className="mt-4 max-w-xs text-sm text-slate-500">{site?.tagline || data.tagline}</p>
          <div className="mt-6 flex gap-3">
            {data.social.map((s, i) => (
              <a key={i} href={s.url} className="flex h-10 w-10 items-center justify-center rounded-full glass text-slate-500 transition-colors hover:text-brand" aria-label={s.icon} data-testid={`social-${s.icon.toLowerCase()}`}>
                <Icon name={s.icon} size={18} />
              </a>
            ))}
          </div>
        </div>
        {data.columns.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-semibold text-slate-900">{col.title}</h4>
            <ul className="mt-4 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  {/^https?:\/\//.test(l.path) ? (
                    <a href={l.path} target="_blank" rel="noopener noreferrer" className="text-sm text-slate-500 transition-colors hover:text-brand">{l.label}</a>
                  ) : (
                    <Link to={l.path} className="text-sm text-slate-500 transition-colors hover:text-brand">{l.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-200/70 py-6 text-center text-xs text-slate-400">{site?.copyright || data.copyright}</div>
      {links?.support && (
        <a href={links.support} target="_blank" rel="noopener noreferrer" data-testid="floating-support"
          className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-brand-2 text-white shadow-lg transition-transform hover:scale-110" aria-label="Support">
          <Icon name="MessageCircle" size={24} />
        </a>
      )}
    </footer>
  );
}
